import { IsNotEmpty, IsUUID, IsBoolean, IsOptional } from 'class-validator';

export class UpdateCompanyManagerSettingsDto {
  @IsUUID()
  @IsNotEmpty()
  companyId: string;

  @IsBoolean()
  @IsOptional()
  importOperationalUnits?: boolean;

  @IsBoolean()
  @IsOptional()
  importLegalUnits?: boolean;

  @IsBoolean()
  @IsOptional()
  showOperationalManager?: boolean;

  @IsBoolean()
  @IsOptional()
  showLegalManager?: boolean;

  @IsBoolean()
  @IsOptional()
  showFunctionalManager?: boolean;
}
